import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {SchemaCollaborator} from 'auth/PermissionConstants';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

import {CollaboratorInfoGraphQL} from '../../../graphql-fragments/auth/__generated/CollaboratorInfoGraphQL';

export function testDefinitionsListingURL(): string {
  return '/test-definitions/listing';
}

export function getCreateTestDefinitionURL(): string {
  return '/test-definitions/create';
}

export function getTestDefinitionURL(testDefinitionId: string): string {
  return `/test-definitions/${testDefinitionId}`;
}

export interface CreateTestDefinitionParams {
  name: string;
  collaborators: Array<SchemaCollaborator>;
  organizationId: string;
  resultSchemaId: string;
  description: string;
}

export interface CreateTestDefinitionResponse {
  createdIds: Array<string>;
}

export function createTestDefinition(
  testDefinition: CreateTestDefinitionParams
): Promise<CreateTestDefinitionResponse> {
  const creates = [testDefinition];
  return postJSONPromise({url: getApiBaseForObjectType(DomainGraphType.TEST_DEFINITION), data: {creates}});
}

export interface UpdateTestDefinitionParams extends UpdateArchivableParams {
  id: string;
  name?: string;
  organizationId?: string;
  resultSchemaId?: string;
  description?: string;
}

export interface UpdateTestDefinitionResponse {
  updatedIds: Array<string>;
}

export function updateTestDefinition(
  testDefinition: UpdateTestDefinitionParams
): Promise<UpdateTestDefinitionResponse> {
  const updates = [testDefinition];
  return patchJSONPromise({url: getApiBaseForObjectType(DomainGraphType.TEST_DEFINITION), data: {updates}});
}

export interface UpdateTestDefinitionCollaboratorsRequest {
  collaborators: Array<SchemaCollaborator>;
}

interface UpdateTestDefinitionCollaboratorsResponse {
  testDefinition: CollaboratorInfoGraphQL;
}

export function updateCollaborators(
  testDefinitionId: string,
  data: UpdateTestDefinitionCollaboratorsRequest
): Promise<UpdateTestDefinitionCollaboratorsResponse> {
  return patchJSONPromise({
    url: `${getApiBaseForObjectType(DomainGraphType.TEST_DEFINITION)}/${testDefinitionId}/collaborators`,
    data,
  });
}
